import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";
import { authenticatedApi } from "api";

const endpoint:string = 'contacts';

export function useGetAllContacts(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetContact(id: number, queryParams:any = {}) {
    return useGetOne({
        queryKey: [endpoint, id],
        select: (data) => {
            if(data?.user) {
                data.role_id = data?.user?.roles?.[0]?.id;
                data.has_access = data?.user_id ? true : false;
            }
            return data;
        },
        ...queryParams,
    });
}

export function useCreateContact() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateContact({id}) {
    return useUpdate({queryKey: [endpoint, id]});
    /*
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (params:any = {}) => {
            const { data } = await authenticatedApi.put(`/${endpoint}/${id}`, params);
            return data;//data.hasOwnProperty('data') ? data.data : data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [endpoint, id] });
            // queryClient.invalidateQueries({ queryKey: [endpoint] });
        },
    });
    */
}

export function useDeleteContact({id}) {
    return useDelete({queryKey: [endpoint, id]});
    /*
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (/*params:any = {}*\/) => {
            const { data } = await authenticatedApi.delete(`/${endpoint}/${id}`);
            return data;//data.hasOwnProperty('data') ? data.data : data;
        },
        onSuccess: () => {
            // queryClient.invalidateQueries({ queryKey: [endpoint, id] });
            queryClient.invalidateQueries({ queryKey: [endpoint] });
        },
    });
    */
}


export function getProfilePhoto(contact) {
    let $logo = null;

    for (let file in contact.files) {
        if( contact.files[file].type == 'profile' )
        {
            if (!$logo || $logo.created_at < contact.files[file].created_at) {
                $logo =  contact.files[file];
            }
        }
    }

    return $logo;
};

export function getPreferredPhone(contact: any) {

    if(contact.preferred_contact_method === 'home' && contact.home_phone) {
        return contact.home_phone;
    }

    if(contact.preferred_contact_method === 'cell' && contact.cell_phone) {
        return contact.cell_phone;
    }

    if(contact.preferred_contact_method === 'work' && contact.work_phone) {
        return contact.work_phone;
    }

    if(contact.home_phone) {
        return contact.home_phone;
    }

    if(contact.cell_phone) {
        return contact.cell_phone;
    }

    if(contact.work_phone) {
        return contact.work_phone;
    }

    return null;
}
